import { request } from '../../../../../../../../../../1stlog-ui/src/utils'
import { TOrderEntryReusableBoxInfo } from '../../../../../../../AdditionalServices/types'

export default function createValidateReusableBox(
  url: string,
  customerId: string | number | undefined,
  onResult: (value: TOrderEntryReusableBoxInfo | null) => void,
) {
  return async function validateReusableBox(
    value: string,
  ): Promise<string | null> {
    try {
      // console.log("validateReusableBox", value)
      if (!value || value === '') {
        return 'Muss ausgefüllt werden'
      }
      const { data } = await request<TOrderEntryReusableBoxInfo | string>({
        method: 'post',
        url,
        data: {
          reusableBoxIdentifier: value,
          customerId,
        },
      })
      if (data && data !== 'undefined' && data !== 'false') {
        onResult(data as TOrderEntryReusableBoxInfo)
        return null
      }
      onResult(null)
      return 'Muss ausgefüllt werden'
    } catch (err) {
      return i18n.t(
        'validation_error_checking_reusable_box',
        'Fehler bei der Suche nach Mehrwegbox. Bitte versuchen Sie es später erneut.',
      )
    }
  }
}
